import { render, staticRenderFns } from "./DebtorStatement.vue?vue&type=template&id=7b4ac842&"
import script from "./DebtorStatement.vue?vue&type=script&lang=js&"
export * from "./DebtorStatement.vue?vue&type=script&lang=js&"
import style0 from "./DebtorStatement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports